<script>
import WorkshopNav from "@/common/workshop-nav";
import GenericNavbar from "@/components/header/GenericNavbar.vue";

export default {
  name: "WorkshopNavbar",
  components: {
    GenericNavbar
  },
  props: {
    block: {
      type: String,
      default: "navbar"
    },
    triggerId: {
      type: String,
      required: true
    }
  },
  emits: ["close"],
  methods: {
    getNavigationItems: WorkshopNav.getItems,

    hideMenu() {
      this.$emit("close");
    }
  }
};
</script>

<template>
  <GenericNavbar
    :block="block"
    :trigger-id="triggerId"
    :items="getNavigationItems()"
    @toggle="hideMenu()"
    @hide="hideMenu()"
  />
</template>
